import { useEffect, useState } from "react";
import { makeStyles, Button, Dialog } from "@fluentui/react-components";
import { IconX } from "@tabler/icons-react";
import UserProfileForm from "./UserProfileForm";

const useClasses = makeStyles({
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(16, 54, 153, 0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center", // Align to the top
        // paddingTop: "", // Add slight space from the top
        zIndex: 1000,
        "@media (max-width: 600px)": {
            justifyContent: "center",
            alignItems: "flex-start",
            paddingTop: "3vh"
        }
    },

    panel: {
        width: "420px", // Increased width
        height: "auto", // Allow for flexible height
        maxHeight: "100vh", // Increase the height limit to 90% of viewport height
        padding: "10px", // Slight padding for breathing room
        overflow: "auto", // Allow scrolling if content exceeds panel size
        display: "flex",
        flexDirection: "column",
        borderRadius: "8px",
        background: "#ffffff",
        "@media (max-width: 600px)": {
            maxHeight: "95vh",
            width: "90vw"
        }
    },
    container: {
        padding: "8px 8px 0 8px", // Reduce bottom padding for compactness
        flexDirection: "column",
        alignItems: "flex-start",
        background: "#ffffff",
        overflowY: "auto",
        "@media (max-width: 600px)": {
            padding: "8px 8px 0 8px"
        }
    },

    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        color: "#103699",
        fontFamily: "Poppins",
        fontWeight: "bold",
        fontSize: "20px",
        marginBottom: "8px" // Reduce space below the header
    },
    headerText: {
        flex: 1,
        textAlign: "center"
    },
    closeButton: {
        minWidth: "12px" // Smaller close button
    }
});

export interface UserProfilePanelProps {
    isOpen: boolean;
    onClose: () => void;
    onFormSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
    isProfileUpdate: boolean;
    isSaving: boolean;
    profileErrorMessage: string;
}

export const UserProfilePanel = (props: UserProfilePanelProps) => {
    const classes = useClasses();
    return (
        <div className={classes.overlay}>
            <Dialog open={props.isOpen} onOpenChange={(_event, data) => !data.open && props.onClose()}>
                <div className={classes.panel}>
                    <div className={classes.header}>
                        <div className={classes.headerText}>{props.isProfileUpdate ? "Update your profile" : "Create your profile"}</div>
                        {props.isProfileUpdate && (
                            <Button className={classes.closeButton} aria-label="Close dialog" onClick={props.onClose}>
                                <IconX color="#797979" size={16} />
                            </Button>
                        )}
                    </div>
                    <UserProfileForm
                        onFormSubmit={props.onFormSubmit}
                        isProfileUpdate={props.isProfileUpdate}
                        isSaving={props.isSaving}
                        profileErrorMessage={props.profileErrorMessage}
                    />
                </div>
            </Dialog>
        </div>
    );
};
